import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class EventsManagerService {
  private events: any = {
    _onConnectionMonitorChange: new Subject(),
    _onConnectionSetup: new Subject(),
    _onConnectivityRecovered: new Subject(),
    _onCustomEvent: new Subject(),
    _onDeviceAdded: new Subject(),
    _onEnergyConfigSaved: new Subject(),
    _onForbiddenRequest: new Subject(),
    _onHttpRequestError: new Subject(),
    _onInvalidLocations: new Subject(),
    _onNoConnection: new Subject(),
    _onRecoverConnection: new Subject(),
    _onRestoreNetworkStatus: new Subject(),
    _onServerConnectivityError: new Subject(),
    _onTokenRefreshError: new Subject(),
    _onTokenRefreshStart: new Subject(),
    _onTokenRefreshed: new Subject(),
    _onUnAuthenticated: new Subject(),
    _onUserSignIn: new Subject(),
    _onUserSignOut: new Subject()
  };

  public static ON_CUSTOM_EVENT: string = '_onCustomEvent';
  public static ON_SERVER_CONNECTIVITY_ERROR: string = '_onServerConnectivityError';
  public static ON_TOKEN_REFRESH_START: string = '_onTokenRefreshStart';
  public static ON_TOKEN_REFRESHED: string = '_onTokenRefreshed';
  public static ON_TOKEN_REFRESH_ERROR: string = '_onTokenRefreshError';
  public static ON_USER_SIGN_OUT: string = '_onUserSignOut';
  public static ON_USER_SIGN_IN: string = '_onUserSignIn';
  public static ON_CONNECTION_MONITOR_CHANGE: string = '_onConnectionMonitorChange';
  public static ON_CONNECTION_SETUP: string = '_onConnectionSetup';
  public static ON_CONNECTIVITY_RECOVERED: string = '_onConnectivityRecovered';
  public static ON_RESTORE_NETWORK_STATUS: string = '_onRestoreNetworkStatus';
  public static ON_INVALID_LOCATIONS: string = '_onInvalidLocations';
  public static ON_DEVICE_ADDED: string = '_onDeviceAdded';
  public static ON_ENERGY_CONFIG_SAVED: string = '_onEnergyConfigSaved';
  public static ON_HTTP_REQUEST_ERROR: string = '_onHttpRequestError';
  public static ON_UNAUTHENTICATED: string = '_onUnAuthenticated';
  public static ON_NO_CONNECTION: string = '_onNoConnection';
  public static ON_RECOVER_CONNECTION: string = '_onRecoverConnection';
  public static ON_FORBIDDEN_REQUEST: string = '_onForbiddenRequest';

  public get onForbiddenRequest(): Observable<any> {
    return this.events._onForbiddenRequest.asObservable();
  }

  public get onRecoverConnection(): Observable<any> {
    return this.events._onRecoverConnection.asObservable();
  }

  public get onNoConnection(): Observable<any> {
    return this.events._onNoConnection.asObservable();
  }

  public get onUnAuthenticated(): Observable<any> {
    return this.events._onUnAuthenticated.asObservable();
  }
  public get onServerConnectivityError(): Observable<any> {
    return this.events._onServerConnectivityError.asObservable();
  }

  public get onConnectionMonitorChange(): Observable<any> {
    return this.events._onConnectionMonitorChange.asObservable();
  }

  public get onConnectionSetup(): Observable<any> {
    return this.events._onConnectionSetup.asObservable();
  }

  public get onConnectivityRecovered(): Observable<any> {
    return this.events._onConnectivityRecovered.asObservable();
  }

  public get onUserSignIn(): Observable<any> {
    return this.events._onUserSignIn.asObservable();
  }

  public get onUserSignOut(): Observable<any> {
    return this.events._onUserSignOut.asObservable();
  }

  public get onTokenRefreshStart(): Observable<any> {
    return this.events._onTokenRefreshStart.asObservable();
  }

  public get onTokenRefreshed(): Observable<any> {
    return this.events._onTokenRefreshed.asObservable();
  }

  public get onTokenRefreshError(): Observable<any> {
    return this.events._onTokenRefreshError.asObservable();
  }

  public get onRestoreNetworkStatus(): Observable<any> {
    return this.events._onRestoreNetworkStatus.asObservable();
  }

  public get onInvalidLocations(): Observable<any> {
    return this.events._onInvalidLocations.asObservable();
  }

  public get onDeviceAdded(): Observable<any> {
    return this.events._onDeviceAdded.asObservable();
  }

  public get onEnergyConfigSaved(): Observable<any> {
    return this.events._onEnergyConfigSaved.asObservable();
  }

  public get onHttpRequestError(): Observable<any> {
    return this.events._onHttpRequestError.asObservable();
  }

  public onCustomEvent(event: string): Observable<any> {
    return this.events[EventsManagerService.ON_CUSTOM_EVENT]
      .asObservable()
      .filter((e: any) => e.event === event);
  }

  public trigger(event: string, data?: any) {
    if (this.events[event] && this.events[event] instanceof Subject) {
      this.events[event].next(data || {});
    }
  }

  public triggerCustom(event: string, data?: any) {
    this.events[EventsManagerService.ON_CUSTOM_EVENT].next(
      Object.assign({ event }, data || {})
    );
  }
}
